import "./assets/styles/main.scss"
import "./i18n"
import "./themes/generated/theme.base.css"
import "./themes/generated/theme.additional.css"
import "./dx-styles.scss"
import "devextreme/dist/css/dx.common.css"
import Cookies from "js-cookie"
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom"
import LoadPanel from "devextreme-react/load-panel"
import { NavigationProvider, withNavigationWatcher } from "./core/context/NavigationContext"
import { AuthProvider, useAuth } from "./features/auth/context/authContext"
import { useScreenSizeClass } from "./core/hook/useScreenSize"
import UnauthenticatedContent from "./features/auth/component/UnauthenticatedContent"
import { licenseKey } from "./devextreme-license"
import { config } from "devextreme/common"
import { RouteItem, routes } from './core/navigation/appRoutes';
import { PopupProvider } from "./core/context/PopupContext"
import { Bounce, ToastContainer } from "react-toastify"
import { PrivateRoute } from "./features/auth/component/PrivateRoute"
import { DashboardDateRangeProvider } from "./features/dashboard/context/DashboardDateRangeContext"
import { SidebarProvider } from "./core/common/sidebar/context/SidebarContext"
import { ModalProvider } from "./core/common/modal/ModalContext"
import { ContentWrapper, Header, Sidebar } from "./core/components"

config({ licenseKey })

function App() {
    const { isLoggedIn, loading } = useAuth()

    if (loading) {
        return <LoadPanel visible={true} />
    }

    const createRoute = (route: RouteItem) => (
        <Route
            key={route.path}
            path={route.path}
            element={withNavigationWatcher(route.element, route.path)} />
    )

    const createPrivateRoute = (route: RouteItem) => (
        <Route
            key={route.path}
            path={route.path}
            element={
                <PrivateRoute
                    element={withNavigationWatcher(route.element, route.path)}
                    allowedRoles={route.allowedRoles} />
            } />
    )

    if (!!Cookies.get("UserLoginCookie") || isLoggedIn) {
        return (
            <Routes>
                {routes.map((route) => {
                    if (!route.allowedRoles)
                        return createRoute(route)
                    return createPrivateRoute(route)
                })}
                <Route
                    path='*'
                    element={<Navigate to='/dashboard' />} />
            </Routes>)
    }

    return <UnauthenticatedContent />
}

export default function Root() {
    const screenSizeClass = useScreenSizeClass()

    return (
        <AuthProvider>
            <Router>
                <NavigationProvider>
                    <ModalProvider>
                        <SidebarProvider>
                            <Header />
                            <div className={`app ${screenSizeClass}`}>
                                <Sidebar />
                                <ContentWrapper>
                                    <DashboardDateRangeProvider>
                                        <PopupProvider>
                                             <ToastContainer
                                                position="top-right"
                                                autoClose={5000}
                                                hideProgressBar={false}
                                                newestOnTop={false}
                                                closeOnClick={false}
                                                rtl={false}
                                                pauseOnFocusLoss
                                                draggable
                                                pauseOnHover
                                                theme="light"
                                                transition={Bounce}
                                            />
                                            <App />
                                        </PopupProvider>
                                    </DashboardDateRangeProvider>
                                </ContentWrapper>
                            </div>
                        </SidebarProvider>
                    </ModalProvider>
                </NavigationProvider>
            </Router>
        </AuthProvider>
    )
}
